import { render } from "./BaseList.vue?vue&type=template&id=c3335b8a&scoped=true"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"

import "./BaseList.vue?vue&type=style&index=0&id=c3335b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3335b8a"]])

export default __exports__